import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FaEye, FaEyeSlash  } from "react-icons/fa";
import EAIMLogo from "../img/eaim_logo_w.png";

const bg = require("../img/classroom_bg.png");
const API = process.env.REACT_APP_API || "";
const LOGIN_ENDPOINT = `${API}/login`;


export default function LoginPage() {
  const navigate = useNavigate();

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");

  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setMsg("");

    if (!userName.trim() || !password) {
      setMsg("Username and password are required. Please try again.");
      return;
    }

    try {
      setLoading(true);

      const res = await axios.post(
        LOGIN_ENDPOINT,
        { userName: userName.trim(), password },
        { headers: { "Content-Type": "application/json" } }
      );

      if (!res.data?.success) {
        setMsg(res.data?.message || "Login failed.");
        return;
      }
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("user", JSON.stringify(res.data.user || {}));

      navigate("/overview");
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err?.message ||
        "Server error. Please try again later.";
      setMsg(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundImage: `url(${bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "grid",
        placeItems: "center",
        padding: 16,
        fontFamily:
          "Manrope-Regular, system-ui, -apple-system, Segoe UI, Roboto, Arial",
      }}
    >
       <img src={EAIMLogo} alt="EAIM Logo" style={{ height: 80, objectFit: "contain" }} />
      <div
        style={{
          width: "min(420px, 92vw)",
          background: "rgba(255,255,255,0.92)",
          borderRadius: 18,
          boxShadow: "0 18px 60px rgba(0,0,0,0.25)",
          padding: 22,
          backdropFilter: "blur(6px)",
        }}
      >
       
        <div style={{ textAlign: "center", marginBottom: 14 }}>
          <div style={{ fontWeight: 900, fontSize: 22 }}>Welcome Back</div>
          <div style={{ opacity: 0.75, marginTop: 4 }}>
            Login to enter the system
          </div>
        </div>

        {msg ? (
          <div
            style={{
              background: "rgba(220,53,69,0.12)",
              border: "1px solid rgba(220,53,69,0.25)",
              color: "#b02a37",
              padding: "10px 12px",
              borderRadius: 12,
              marginBottom: 12,
              fontSize: 14,
            }}
          >
            {msg}
          </div>
        ) : null}

        <form onSubmit={onSubmit}>
          <label style={{ fontSize: 13, fontWeight: 700 }}>Username</label>
          <input
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
            placeholder="Enter username"
            autoComplete="username"
            disabled={loading}
            style={{
              width: "100%",
              padding: "12px 14px",
              borderRadius: 14,
              border: "1px solid rgba(0,0,0,0.15)",
              background: "#f7f7f9",
              color: "#222", 
              fontSize: 14,
              outline: "none",
              marginBottom: 12,
            }}
          />

          <label style={{ fontSize: 13, fontWeight: 700 }}>Password</label>

          <div className="login-password-wrapper">
            <input
              type={showPass ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              autoComplete="current-password"
              disabled={loading}
              style={{
                width: "100%",
                padding: "12px 14px",
                borderRadius: 14,
                border: "1px solid rgba(0,0,0,0.15)",
                background: "#f7f7f9",
                color: "#222", 
                fontSize: 14,
                outline: "none",
                marginBottom: 12,
              }}
            />

            <button
              type="button"
              className="login-eye-btn"
              onClick={() => setShowPass((v) => !v)}
              tabIndex={-1}
              aria-label="Toggle password visibility"
            >
              {showPass ? <FaEyeSlash color="black" style={{marginTop: "-10px"}}/> : <FaEye color="black" style={{marginTop: "-10px"}}/>}
            </button>
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              padding: "12px 14px",
              borderRadius: 14,
              border: "none",
              background: loading ? "#999" : "#6f2cff",
              color: "#fff",
              fontWeight: 900,
              cursor: loading ? "not-allowed" : "pointer",
            }}
          >
            {loading ? "Signing in..." : "Login"}
          </button>

          <div
            style={{
              textAlign: "center",
              marginTop: 12,
              fontSize: 13,
              opacity: 0.75,
            }}
          >
            Please use your SEMS Account to Log In.
          </div>
        </form>
      </div>
    </div>
  );
}
